module.exports = __webpack_public_path__ + "img/ico-radio.5825df04.svg";